import moment from "moment";
const NUMERIC_DATA_TYPES = ['number', 'quantity', 'currency'];
let DATETIME_FORMATTER = 'DD-MMM-YYYY HH:mm:ss'
let DATE_FORMATTER = 'DD-MMM-YYYY'
export const jsPDFHeader = (doc, CompanyName = '', CompanyID, reportTitle = '', scale = 1, pageWidth = 0) => {

    // Scaled values
    const headerHeight = 40 * scale;
    const padding = 10 * scale;
    const logoWidth = 30 * scale;
    const logoHeight = 30 * scale;
    const titleFontSize = 16 * scale;
    const companyFontSize = 16 * scale;

    // Logo
    doc.addImage(
        '/images/logo.png',
        'PNG',
        padding,
        (headerHeight - logoHeight) / 2,
        logoWidth,
        logoHeight
    );

    doc.setFont("Roboto", "bold");
    doc.setFontSize(titleFontSize);
    doc.setTextColor(16, 79, 162);
    // doc.text(
    //     `${CompanyName}(${CompanyID})`,
    //     padding + logoWidth + 4 * scale,
    //     (logoHeight / 2) + (titleFontSize / 2)
    // );

    doc.setFontSize(companyFontSize);
    doc.setTextColor(0, 0, 0);
    doc.text(
        `Report Name : ${reportTitle}`,
        pageWidth - padding,
        (logoHeight / 2) + (companyFontSize / 2),
        { align: "right" }
    );
};
export const jsPdfHeaderFooter = (data, userData, totalPagesExp, scale, pageHeight, pageWidth) => {
    const padding = 10 * scale;
    const footerY = pageHeight - 10;
    const lineY = footerY - 7;

    const doc = data.doc
    var str = 'Page : ' + doc.internal.getNumberOfPages()
    doc.setFontSize(scale * 14)
    doc.setLineWidth(0.5);
    // doc.line(0, lineY, pageWidth, lineY);
    doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, 'right')
    doc.text(
        str,
        pageWidth - padding,
        pageHeight - 5,
        { align: "right" }
    );
    doc.setFont('Roboto', 'bold')
    doc.text(`Report By : ${userData?.AgentName}`, padding, pageHeight - 5)
    doc.text(
        `Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`,
        doc.internal.pageSize.width / 2 -
        (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize()) /
        2 +
        90,
        pageHeight - 5
    )
}
export const calculateTotalTableWidth = (columns) => {
    let totalWidth = 0;
    columns.forEach((column) => {
        const minCellWidth = column.pdfColSx.minCellWidth;
        totalWidth += minCellWidth;
    });

    return totalWidth;
};
export const calculateDynamicFormatLandscape = (desiredWidth) => {
    const a4LandscapeAspectRatio = 1122 / 793;

    const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

    return [desiredWidth, dynamicHeight];
};
export const calculateDynamicFormatPortrait = (desiredWidth) => {
    const a4LandscapeAspectRatio = 793 / 1122;

    const dynamicHeight = Math.round(desiredWidth / a4LandscapeAspectRatio);

    return [desiredWidth, dynamicHeight];
};


export const generateDynamicColumnStyles = (columnCount, Size, minCellDataHeight = 32, cellPadding = 6) => {
    let columnStyles = {}
    let columnIndex = 0
    // Iterate through each header configuration in BranchTransferHeader
    columnCount.forEach((headerConfig) => {
        columnStyles[columnIndex] = { ...headerConfig?.pdfColSx, "fontSize": Size, minCellHeight: minCellDataHeight, cellPadding };
        columnIndex += 1
    });
    return columnStyles;
}
export const jsPdfDidParseCellCallback = (data, pdfColumns, itemValueColumns, fontSize = 12) => {
    if ((data.row.raw.isSubHeadingRow || data.row.raw.isFooterRow || data.row.raw.isSubFooterRow || data.row.raw.isSignatureRow || data.row.raw.isTotalRow || data.row.raw.isNoDataRow || data.row.raw.isChildRow || data.row.raw.isHeaderRow) && data.row.section !== 'head') {
        if (data.row.raw.isSubHeadingRow) {
            if (Array.isArray(data?.row?.raw?.subHeadingData)) {
                let prevColSpan = 0;
                data.row.raw.subHeadingData.forEach((subHeadingObj, index) => {
                    let cellValue = '';
                    if (subHeadingObj.hasOwnProperty('caption'))
                        cellValue += subHeadingObj.caption;
                    if (subHeadingObj.hasOwnProperty('value'))
                        cellValue += ' ' + subHeadingObj.value;
                    const startColSpanIndex = prevColSpan;
                    data.row.cells[startColSpanIndex].text = cellValue;
                    data.row.cells[startColSpanIndex].colSpan = subHeadingObj.colSpan;
                    data.row.cells[startColSpanIndex].styles.halign = "left";
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = fontSize;
                    if (subHeadingObj.hasOwnProperty('align')) {
                        data.row.cells[startColSpanIndex].styles.halign = subHeadingObj.align;
                    }
                    prevColSpan = startColSpanIndex + subHeadingObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isFooterRow) {
            if (Array.isArray(data?.row?.raw?.footerData)) {
                let prevColSpan = 0;
                data.row.raw.footerData.forEach((footerObj, index) => {
                    let cellValue = '';
                    const startColSpanIndex = prevColSpan;
                    if (footerObj.hasOwnProperty('caption'))
                        cellValue += footerObj.caption;
                    if (footerObj.hasOwnProperty('value'))
                        cellValue += ' ' + footerObj.value;

                    data.row.cells[startColSpanIndex].text = cellValue;
                    data.row.cells[startColSpanIndex].colSpan = 18;
                    data.row.cells[startColSpanIndex].styles.halign = "left";
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = fontSize;
                    if (footerObj.hasOwnProperty('align')) {
                        data.row.cells[startColSpanIndex].styles.halign = footerObj.align;
                    }
                    prevColSpan = startColSpanIndex + footerObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isSubFooterRow) {
            if (Array.isArray(data?.row?.raw?.subFooterData)) {
                let prevColSpan = 0;
                data.row.raw.subFooterData.forEach((footerObj, index) => {
                    data.row.cells[0].text = footerObj.value;
                    data.row.cells[0].colSpan = 13;
                    data.row.cells[0].styles.halign = "left";
                    data.row.cells[0].styles.font = "Roboto";
                    data.row.cells[0].styles.fontSize = fontSize;
                });
            }
        }
        else if (data.row.raw.isSignatureRow) {
            if (Array.isArray(data?.row?.raw?.subSignatureData)) {
                let prevColSpan = 0;
                data.row.raw.subSignatureData.forEach((footerObj, index) => {
                    const startColSpanIndex = prevColSpan;
                    data.row.cells[startColSpanIndex].text = footerObj.value;
                    data.row.cells[startColSpanIndex].colSpan = footerObj.colSpan;
                    data.row.cells[startColSpanIndex].styles.halign = footerObj.halign;
                    data.row.cells[startColSpanIndex].styles.font = "Roboto";
                    data.row.cells[startColSpanIndex].styles.fontSize = fontSize;
                    prevColSpan = startColSpanIndex + footerObj.colSpan;
                });
            }
        }
        else if (data.row.raw.isTotalRow) {
            let prevColSpan = 0;
            if (data.row.raw?.hasOwnProperty('collectionBy')) {
                data.row.cells[prevColSpan].colSpan = data.row.raw?.collectionColSpan;
                data.row.cells[prevColSpan].text = [data.row.raw?.collectionCaption + ' ' + data.row.raw?.collectionBy];
                prevColSpan += data.row.raw?.collectionColSpan;
            }
            data.row.cells[prevColSpan].colSpan = data.row.raw?.colSpan;
            data.row.cells[prevColSpan].text = [data.row.raw?.totalCaption || 'Total'];
            data.row.cells[prevColSpan].styles.halign = data.row.raw?.align || 'right';
        } else if (data.row.raw.isNoDataRow) {
            data.row.cells[0].colSpan = pdfColumns.length;
            data.row.cells[0].text = [data.row.raw?.rowCaption || ''];
            data.row.cells[0].styles.textColor = [255, 0, 0];
            data.row.cells[0].styles.halign = 'center';
        } else if (data.row.raw.isChildRow) {
            data.row.cells[1].colSpan = data.row.raw.colSpan;
            data.row.cells[1].text = [data.row.raw?.text || ''];
            data.row.cells[1].styles.halign = 'left';
        }
        else if (data.row.raw.isHeaderRow) {
            if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
                data.cell.styles.halign = "right";
            } else {
                data.cell.styles.halign = "left";
            }
        }
    } else if (data.row.section === 'head') {
        if (NUMERIC_DATA_TYPES.indexOf(data.column.raw.xlCol.dataType) !== -1) {
            data.cell.styles.halign = "right";
        } else {
            data.cell.styles.halign = "left";
        }
    } else if (data.row.raw.rowSpan && data.row.raw.rowSpan > 1) {
        data.row.cells[0].rowSpan = data.row.raw.rowSpan;
        data.row.cells[1].styles.valign = 'middle';
    }
}

export const jsPdfWillDrawCellCallback = (data, isBackWhite = false, companyID = '', fontSize = 12) => {
    const pdoc = data.doc;
    if ((data.row.raw.isSubHeadingRow || data.row.raw.isTotalRow || data.row.raw.isHeaderRow || data.row.raw.isChildRow) && data.row.section !== 'head') {
        pdoc.setFont('Roboto', 'bold');
        pdoc.setFontSize(fontSize);

        if (data.row.raw.isSubHeadingRow)
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
                pdoc.setTextColor(23, 23, 23);
            } else {
                pdoc.setFillColor(245, 250, 254);
            }
        else if (data.row.raw.isTotalRow) {
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
            } else {
                pdoc.setFillColor(241, 241, 241);
            }
        }
        else if (data.row.raw.isHeaderRow) {
            if (isBackWhite) {
                pdoc.setFillColor(255, 255, 255);
                pdoc.setTextColor(0, 0, 0);
            } else {
                pdoc.setFillColor(30, 89, 167);
                pdoc.setTextColor(255, 255, 255);
            }

        }

        if (data.row.raw.isHeaderRow) {
            data.cell.text[0] = data.cell.text[0];
        }
        else if (!data.row.raw.isSubHeadingRow && !data.row.raw.isChildRow) {
            if (data.column.raw.xlCol.dataType === 'quantity') {
                data.cell.text[0] = NumberFormatter(data.cell.text[0], 2);
            } else if (data.column.raw.xlCol.dataType === 'currency') {
                data.cell.text[0] = NumberFormatter(data.cell.text[0], 1);
            } else if (data.column.raw.xlCol.dataType === 'dateTime') {
                data.cell.text[0] = DateTimeFormatter(data.cell.text[0]);
            } else if (data.column.raw.xlCol.dataType === 'date') {
                data.cell.text[0] = DateFormatter(data.cell.text[0]);
            }
        } else if (data.row.raw.isChildRow) {
            pdoc.setFont('Roboto', 'normal');
        }
    } else {
        if (data.column.raw.xlCol.dataType === 'quantity') {
            data.cell.text[0] = NumberFormatter(data.cell.text[0], 2);
        } else if (data.column.raw.xlCol.dataType === 'currency') {
            data.cell.text[0] = NumberFormatter(data.cell.text[0], 1);
        } else if (data.column.raw.xlCol.dataType === 'string') {
            if (data.cell.text.length > 2) {
                const cellData = data.cell.text.slice(0, 2);
                cellData[1] = cellData[1].length > 8 ? `${cellData[1].slice(0, 5)}...` : `${cellData[1]}...`
                data.cell.text = cellData;
            }
            else if (data.cell.text.length > 1 && data.cell.text.length < 2) {
                data.cell.text[0] = data.cell.text[0];
            } else {
                data.cell.text = data.cell.text;
            }
        }
    }
}


export const DateTimeFormatter = (date) => {
    return moment(date).format(DATETIME_FORMATTER);
}


export const DateFormatter = (date) => {
    return moment(date).format(DATE_FORMATTER);
}


export const NumberFormatter = (value, decimal) => {
    if (Number.isInteger(value)) {
        return parseFloat(parseFloat(value).toFixed(0)).toLocaleString(
            "en-IN",
            {
                useGrouping: true,
                minimumFractionDigits: 0
            }
        );
    }
    else {
        return parseFloat(parseFloat(value).toFixed(decimal || 2)).toLocaleString(
            "en-IN",
            {
                useGrouping: true,
                minimumFractionDigits: decimal || 2
            }
        );
    }
};
